import { render, staticRenderFns } from "./CustomerAppointments.vue?vue&type=template&id=1508cc36&"
import script from "./CustomerAppointments.vue?vue&type=script&lang=js&"
export * from "./CustomerAppointments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports